export class ShareKeyList {
    [sharekeyid: string]: string;
}
